import { useTranslation } from 'react-i18next';

/** Visible lobby chips only — live/instant/providers hidden from UI (data kept in DB). */
export type GameCategory = 'all' | 'slots';

const CATEGORIES: GameCategory[] = ['all', 'slots'];

interface Props {
  value: GameCategory | string;
  onChange: (value: GameCategory) => void;
}

export function CategoryChips({ value, onChange }: Props) {
  const { t } = useTranslation('games');
  const current = value === 'slots' ? 'slots' : 'all';

  return (
    <div className="chips" role="tablist" aria-label={t('categories')}>
      {CATEGORIES.map((category) => (
        <button
          key={category}
          type="button"
          role="tab"
          aria-selected={current === category}
          className={`chip${current === category ? ' active' : ''}`}
          onClick={() => onChange(category)}
        >
          {t(category)}
        </button>
      ))}
    </div>
  );
}
